export const getConstructedLink = (value: string, skeleton: string) => {
  if (!skeleton) {
    return value;
  }
  return skeleton.replace(/\[placeholder\]/g, value);
};
